import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { 
  FETCHING_SKILLS_FAILED, 
  FETCHING_SKILLS_REQUEST, 
  FETCHING_SKILLS_SUCCEEDED, 
  INVALIDATE_SKILLS, 
  SEARCHING_SKILLS_FAILED, 
  SEARCHING_SKILLS_REQUEST, 
  SEARCHING_SKILLS_SUCCEEDED, 
  UPDATE_SKILLS_PREFERENCES_REQUEST, 
  UPDATING_SKILLS_PREFERENCES_SUCCEEDED, 
  UPDATING_SKILLS_PREFERENCES_FAILED, 
  CREATING_SKILL_REQUEST,
  CREATING_SKILL_SUCCEEDED,
  CREATING_SKILL_FAILED,
  UPDATING_SKILL_REQUEST,
  UPDATING_SKILL_SUCCEEDED,
  UPDATING_SKILL_FAILED,
  INVALIDATE_UPDATE_SKILL,
  INVALIDATE_CREATE_SKILL,
  DELETING_SKILL_REQUEST,
  DELETING_SKILL_SUCCEEDED,
  DELETING_SKILL_FAILED,
  INVALIDATE_DELETE_SKILL,
  FETCH_ASSESSMENT_CONFIGURATIONS_REQUEST,
  FETCHING_ASSESSMENT_CONFIGURATIONS_SUCCEEDED,
  FETCHING_ASSESSMENT_CONFIGURATIONS_FAILED,
  CREATE_ASSESSMENT_CONFIGURATION_REQUEST,
  CREATING_ASSESSMENT_CONFIGURATION_SUCCEEDED,
  CREATING_ASSESSMENT_CONFIGURATION_FAILED,
  UPDATE_ASSESSMENT_CONFIGURATION_REQUEST,
  UPDATING_ASSESSMENT_CONFIGURATION_SUCCEEDED,
  UPDATING_ASSESSMENT_CONFIGURATION_FAILED,
  INVALIDATE_ASSESSMENT_CONFIGURATION_CREATION_STATE,
  INVALIDATE_ASSESSMENT_CONFIGURATION_UPDATE_STATE,
  INVALIDATE_ASSESSMENT_CONFIGURATION_DELETION_STATE,
  DELETE_ASSESSMENT_CONFIGURATION_REQUEST,
  DELETING_ASSESSMENT_CONFIGURATION_SUCCEEDED,
  DELETING_ASSESSMENT_CONFIGURATION_FAILED,
  PUBLISH_ASSESSMENT_CONFIGURATION_REQUEST,
  PUBLISHING_ASSESSMENT_CONFIGURATION_SUCCEEDED,
  PUBLISHING_ASSESSMENT_CONFIGURATION_FAILED,
  FETCH_ASSESSMENT_CONFIGURATION_REQUEST,
  FETCHING_ASSESSMENT_CONFIGURATION_SUCCEEDED,
  FETCHING_ASSESSMENT_CONFIGURATION_FAILED,
  UPDATE_ASSESSMENT_CONFIGURATION_PROPERTY,
  DISCARD_ASSESSMENT_CONFIGURATION_DRAFT_REQUEST,
  INVALIDATE_ASSESSMENT_CONFIGURATION_EDIT_STATE,
  DISCARDING_ASSESSMENT_CONFIGURATION_DRAFT_FAILED,
  DISCARDING_ASSESSMENT_CONFIGURATION_DRAFT_SUCCEEDED,
  INVALIDATE_PUBLISH_ASSESSMENT_CONFIGURATION,
  INVALIDATE_ASSESSMENT_CONFIGURATIONS
} from "../actionTypes";

import { createAction } from "@reduxjs/toolkit";

import { 
  CreateSkillErrorResponse, 
  CreateSkillRequest, 
  CreateSkillResponse, 
  DeleteSkillErrorResponse, 
  DeleteSkillResponse, 
  FetchSkillsErrorResponse, 
  FetchSkillsRequest, 
  FetchSkillsResponse, 
  SearchSkillsErrorResponse, 
  SearchSkillsRequest, 
  SearchSkillsResponse, 
  UpdateSkillPreferencesErrorResponse, 
  UpdateSkillPreferencesRequest, 
  UpdateSkillPreferencesResponse 
} from "src/types/coaching/skills";

import axios from "axios";
import buildUrl from "build-url-ts";
import { UpdateSkillErrorResponse, UpdateSkillRequest, UpdateSkillResponse } from "../../../types/coaching/skills";
import { CreateAssessmentConfigurationErrorResponse, CreateAssessmentConfigurationRequest, CreateAssessmentConfigurationResponse, DeleteAssessmentConfigurationErrorResponse, DeleteAssessmentConfigurationRequest, DeleteAssessmentConfigurationResponse, FetchAssessmentConfigurationErrorResponse, FetchAssessmentConfigurationResponse, FetchAssessmentConfigurationsErrorResponse, FetchAssessmentConfigurationsRequest, FetchAssessmentConfigurationsResponse, PublishAssessmentConfigurationErrorResponse, PublishAssessmentConfigurationRequest, PublishAssessmentConfigurationResponse, UpdateAssessmentConfigurationErrorResponse, UpdateAssessmentConfigurationProperty, UpdateAssessmentConfigurationRequest, UpdateAssessmentConfigurationResponse } from "src/types/coaching/assessmentConfiguration";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_COACHING_API_URL}`;

//Fetch Skills
export const fetchSkills = createAction<FetchSkillsRequest>(FETCHING_SKILLS_REQUEST);
const fetchingSkillsSucceeded = createAction<FetchSkillsResponse>(FETCHING_SKILLS_SUCCEEDED);
const fetchingSkillsFailed = createAction<FetchSkillsErrorResponse>(FETCHING_SKILLS_FAILED);

const fetchSkillsSaga = function* (action: ReturnType<typeof fetchSkills>): any {
  const { query, parent, page, limit } = action.payload as FetchSkillsRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/skills`,
    queryParams: {
      query: query,
      parent: parent,
      page: page,
      limit: limit,
    }
  });

  const fetchSkillsAPI = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchSkillsAPI);
    yield put(fetchingSkillsSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingSkillsFailed({ error: error }));
  }
};

//search skills
export const searchSkills = createAction<SearchSkillsRequest>(SEARCHING_SKILLS_REQUEST);
const searchingSkills = createAction<SearchSkillsResponse>(SEARCHING_SKILLS_SUCCEEDED);
const searchingSkillsFailed = createAction<SearchSkillsErrorResponse>(SEARCHING_SKILLS_FAILED);

const searchSkillsSaga = function* (action: ReturnType<typeof searchSkills>): any {

  const { query, parent, page, limit } = action.payload as SearchSkillsRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/skills`,
    queryParams: {
      query: query,
      parent: parent,
      page: page,
      limit: limit,
    }
  });

  const searchSkillsAPI = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(searchSkillsAPI);
    yield put(searchingSkills({
      response: response
    }));

  } catch (error) {
    yield put(searchingSkillsFailed({ error: error }));
  }
}

/**
 * Creating Skill
 */
export const createSkill = createAction<CreateSkillRequest>(CREATING_SKILL_REQUEST);
const creatingSkillSucceeded = createAction<CreateSkillResponse>(CREATING_SKILL_SUCCEEDED);
const creatingSkillFailed = createAction<CreateSkillErrorResponse>(CREATING_SKILL_FAILED);

const createSkillSaga = function* (action: ReturnType<typeof createSkill>): any {
  const request = action.payload as CreateSkillRequest;

  const url = buildUrl(apiUrl, {
    path: `/api/1.0/skills`,

  });

  const createSkillsAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: request,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createSkillsAPI);
    yield put(creatingSkillSucceeded({ skill: response }));
  } catch (error) {
    yield put(creatingSkillFailed({ error: error }));
  }
};

export const invalidateCreateSkill = createAction<void>(INVALIDATE_CREATE_SKILL);

/**
 * Updating Skill
 */
export const updateSkill = createAction<UpdateSkillRequest>(UPDATING_SKILL_REQUEST);
const updatingSkillSucceeded = createAction<UpdateSkillResponse>(UPDATING_SKILL_SUCCEEDED);
const updatingSkillFailed = createAction<UpdateSkillErrorResponse>(UPDATING_SKILL_FAILED);

const updateSkillSaga = function* (action: ReturnType<typeof updateSkill>): any {
  const request = action.payload as UpdateSkillRequest;

  const url = buildUrl(apiUrl, {
    path: `/api/1.0/skills/${request.id}`,

  });

  const updateSkillsAPI = () => {
    return axios({
      method: 'PUT',
      url: url,
      data: request,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateSkillsAPI);
    yield put(updatingSkillSucceeded({ skill: response }));
  } catch (error) {
    yield put(updatingSkillFailed({ error: error }));
  }
};

export const invalidateUpdateSkill = createAction<void>(INVALIDATE_UPDATE_SKILL);

/**
 * Delete Skill
 */
export const deleteSkill = createAction<string>(DELETING_SKILL_REQUEST);
const deletingSkillSucceeded = createAction<DeleteSkillResponse>(DELETING_SKILL_SUCCEEDED);
const deletingSkillFailed = createAction<DeleteSkillErrorResponse>(DELETING_SKILL_FAILED);

const deleteSkillSaga = function* (action: ReturnType<typeof deleteSkill>): any {
  const id = action.payload as string;

  const url = buildUrl(apiUrl, {
    path: `/api/1.0/skills/${id}`,
  });

  const deleteSkillsAPI = () => {
    return axios({
      method: 'DELETE',
      url: url
    }).then((response) => response.data);
  };

  try {
    yield call(deleteSkillsAPI);
    yield put(deletingSkillSucceeded({ id: id }));
  } catch (error) {
    yield put(deletingSkillFailed({ error: error }));
  }
};

export const invalidateDeleteSkill = createAction<void>(INVALIDATE_DELETE_SKILL);

//Update skills preference
export const updateSkillsPreference = createAction<UpdateSkillPreferencesRequest>(UPDATE_SKILLS_PREFERENCES_REQUEST);
const updatingSkillsPreferenceSucceeded = createAction<UpdateSkillPreferencesResponse>(UPDATING_SKILLS_PREFERENCES_SUCCEEDED);
const updatingSkillsPreferenceFailed = createAction<UpdateSkillPreferencesErrorResponse>(UPDATING_SKILLS_PREFERENCES_FAILED);

const updateSkillPreferencesSaga = function* (action: ReturnType<typeof updateSkillsPreference>): any {
  const { skills } = action.payload as UpdateSkillPreferencesRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/explore/skill_preferences`,

  });

  const updateSkillsAPI = () => {
    return axios({
      method: 'PUT',
      url: url,
      data: skills,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateSkillsAPI);
    yield put(updatingSkillsPreferenceSucceeded({ response: response }));
  } catch (error) {
    yield put(updatingSkillsPreferenceFailed({ error: error }));
  }
};

export const invalidateSkills = createAction<void>(INVALIDATE_SKILLS);

export const fetchAssessmentConfiguration = createAction<string>(FETCH_ASSESSMENT_CONFIGURATION_REQUEST);
const fetchingAssessmentConfigurationSucceeded = createAction<FetchAssessmentConfigurationResponse>(FETCHING_ASSESSMENT_CONFIGURATION_SUCCEEDED);
const fetchingAssessmentConfigurationFailed = createAction<FetchAssessmentConfigurationErrorResponse>(FETCHING_ASSESSMENT_CONFIGURATION_FAILED);

const fetchAssessmentConfigurationSaga = function* (action: ReturnType<typeof fetchAssessmentConfiguration>): any {
  const id = action.payload as string;

  const fetchAssessmentConfigurationAPI = () => {
    return axios({
      method: "GET",
      url: `${apiUrl}/api/1.0/assessment-configurations/${id}`,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAssessmentConfigurationAPI);
    yield put(
      fetchingAssessmentConfigurationSucceeded({response})
    );
  } catch (error) {
    yield put(
      fetchingAssessmentConfigurationFailed({
        id: id,
        error: error,
      })
    );
  }
};

//Fetch Assessment Configurations
export const fetchAssessmentConfigurations = createAction<FetchAssessmentConfigurationsRequest>(FETCH_ASSESSMENT_CONFIGURATIONS_REQUEST);
const fetchingAssessmentConfigurationsSucceeded = createAction<FetchAssessmentConfigurationsResponse>(FETCHING_ASSESSMENT_CONFIGURATIONS_SUCCEEDED);
const fetchingAssessmentConfigurationsFailed = createAction<FetchAssessmentConfigurationsErrorResponse>(FETCHING_ASSESSMENT_CONFIGURATIONS_FAILED);

const fetchAssessmentConfigurationsSaga = function* (action: ReturnType<typeof fetchAssessmentConfigurations>): any {
  const { callType, status } = action.payload as FetchAssessmentConfigurationsRequest;

  const fetchAssessmentConfigurationAPI = () => {
    return axios({
      method: "GET",
      url: `${apiUrl}/api/1.0/assessment-configurations`,
      params: {
        callType,
        status
      },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAssessmentConfigurationAPI);
    yield put(
      fetchingAssessmentConfigurationsSucceeded({response})
    );
  } catch (error) {
    yield put(
      fetchingAssessmentConfigurationsFailed({
        error: error,
      })
    );
  }
};

//Create Assessment Configuration
export const createAssessmentConfiguration = createAction<CreateAssessmentConfigurationRequest>(CREATE_ASSESSMENT_CONFIGURATION_REQUEST);
const creatingAssessmentConfigurationSucceeded = createAction<CreateAssessmentConfigurationResponse>(CREATING_ASSESSMENT_CONFIGURATION_SUCCEEDED);
const creatingAssessmentConfigurationFailed = createAction<CreateAssessmentConfigurationErrorResponse>(CREATING_ASSESSMENT_CONFIGURATION_FAILED);

const createAssessmentConfigurationSaga = function* (action: ReturnType<typeof createAssessmentConfiguration>): any {
  const request = action.payload as CreateAssessmentConfigurationRequest;

  const createAssessmentConfigurationAPI = () => {
    return axios({
      method: "POST",
      url: `${apiUrl}/api/1.0/assessment-configurations`,
      data: request,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createAssessmentConfigurationAPI);
    yield put(
      creatingAssessmentConfigurationSucceeded({id: response.id, response: response})
    );
  } catch (error) {
    yield put(
      creatingAssessmentConfigurationFailed({
        error: error,
      })
    );
  }
};

export const invalidateAssessmentConfigurationCreation = createAction<void>(INVALIDATE_ASSESSMENT_CONFIGURATION_CREATION_STATE);

//Update Assessment Configuration 
export const updateAssessmentConfiguration = createAction<UpdateAssessmentConfigurationRequest>(UPDATE_ASSESSMENT_CONFIGURATION_REQUEST);
const updatingAssessmentConfigurationSucceeded = createAction<UpdateAssessmentConfigurationResponse>(UPDATING_ASSESSMENT_CONFIGURATION_SUCCEEDED);
const updatingAssessmentConfigurationFailed = createAction<UpdateAssessmentConfigurationErrorResponse>(UPDATING_ASSESSMENT_CONFIGURATION_FAILED);

const updateAssessmentConfigurationSaga = function* (action: ReturnType<typeof updateAssessmentConfiguration>): any {
  const { id, request } = action.payload as UpdateAssessmentConfigurationRequest;
  
  const updateAssessmentConfigurationAPI = () => {
    return axios({
      method: 'PUT',
      url: `${apiUrl}/api/1.0/assessment-configurations/${id}`,
      data: request,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateAssessmentConfigurationAPI);
    yield put(updatingAssessmentConfigurationSucceeded({ response: response }));
  } catch (error) {
    yield put(updatingAssessmentConfigurationFailed({ id: id, error: error }));
  }
};

export const deleteAssessmentConfiguration = createAction<DeleteAssessmentConfigurationRequest>(DELETE_ASSESSMENT_CONFIGURATION_REQUEST);
const deleteAssessmentConfigurationSucceeded = createAction<DeleteAssessmentConfigurationResponse>(DELETING_ASSESSMENT_CONFIGURATION_SUCCEEDED);
const deleteAssessmentConfigurationFailed = createAction<DeleteAssessmentConfigurationErrorResponse>(DELETING_ASSESSMENT_CONFIGURATION_FAILED);

const deleteAssessmentConfigurationSaga = function* (action: ReturnType<typeof deleteAssessmentConfiguration>): any {
  const { id } = action.payload as DeleteAssessmentConfigurationRequest;

  const deleteAssessmentConfigurationAPI = () => {
    return axios({
      method: 'DELETE',
      url: `${apiUrl}/api/1.0/assessment-configurations/${id}`,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteAssessmentConfigurationAPI);
    yield put(deleteAssessmentConfigurationSucceeded({id: id, response: response}));
  } catch (error) {
    yield put(deleteAssessmentConfigurationFailed({id: id, error: error }));
  }     
};

export const publishAssessmentConfiguration = createAction<PublishAssessmentConfigurationRequest>(PUBLISH_ASSESSMENT_CONFIGURATION_REQUEST);
const publishAssessmentConfigurationSucceeded = createAction<PublishAssessmentConfigurationResponse>(PUBLISHING_ASSESSMENT_CONFIGURATION_SUCCEEDED);
const publishAssessmentConfigurationFailed = createAction<PublishAssessmentConfigurationErrorResponse>(PUBLISHING_ASSESSMENT_CONFIGURATION_FAILED);

const publishAssessmentConfigurationSaga = function* (action: ReturnType<typeof publishAssessmentConfiguration>): any {
  const { id } = action.payload as PublishAssessmentConfigurationRequest;

  const publishAssessmentConfigurationAPI = () => {
    return axios({
      method: 'POST',
      url: `${apiUrl}/api/1.0/assessment-configurations/${id}/publish`,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(publishAssessmentConfigurationAPI);
    yield put(publishAssessmentConfigurationSucceeded({id: id, response: response }));
  } catch (error) {
    yield put(publishAssessmentConfigurationFailed({ id: id, error: error }));
  }
};  

export const discardAssessmentConfiguration = createAction<DeleteAssessmentConfigurationRequest>(DISCARD_ASSESSMENT_CONFIGURATION_DRAFT_REQUEST);
const discardAssessmentConfigurationSucceeded = createAction<DeleteAssessmentConfigurationResponse>(DISCARDING_ASSESSMENT_CONFIGURATION_DRAFT_SUCCEEDED);
const discardAssessmentConfigurationFailed = createAction<DeleteAssessmentConfigurationErrorResponse>(DISCARDING_ASSESSMENT_CONFIGURATION_DRAFT_FAILED);

const discardAssessmentConfigurationSaga = function* (action: ReturnType<typeof discardAssessmentConfiguration>): any {
  const { id } = action.payload as DeleteAssessmentConfigurationRequest;

  const discardAssessmentConfigurationAPI = () => {
    return axios({
      method: 'DELETE',
      url: `${apiUrl}/api/1.0/assessment-configurations/${id}/draft`,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(discardAssessmentConfigurationAPI);
    yield put(discardAssessmentConfigurationSucceeded({id: id, response: response}));
  } catch (error) {
    yield put(discardAssessmentConfigurationFailed({id: id, error: error }));
  }     
};

export const updateAssessmentConfigurationProperty = createAction<UpdateAssessmentConfigurationProperty>(UPDATE_ASSESSMENT_CONFIGURATION_PROPERTY);
export const invalidateAssessmentConfigurationCreationState = createAction<void>(INVALIDATE_ASSESSMENT_CONFIGURATION_CREATION_STATE);
export const invalidateAssessmentConfigurationUpdateState = createAction<void>(INVALIDATE_ASSESSMENT_CONFIGURATION_UPDATE_STATE);
export const invalidateAssessmentConfigurationDeletionState = createAction<void>(INVALIDATE_ASSESSMENT_CONFIGURATION_DELETION_STATE);
export const invalidateAssessmentConfigurationEditState = createAction<void>(INVALIDATE_ASSESSMENT_CONFIGURATION_EDIT_STATE);
export const invalidatePublishAssessmentConfiguration = createAction(INVALIDATE_PUBLISH_ASSESSMENT_CONFIGURATION);
export const invalidateAssessmentConfigurations = createAction<void>(INVALIDATE_ASSESSMENT_CONFIGURATIONS);

export default function* skillsSagas() {
  yield takeEvery(FETCHING_SKILLS_REQUEST, fetchSkillsSaga);
  yield takeEvery(SEARCHING_SKILLS_REQUEST, searchSkillsSaga);
  yield takeEvery(CREATING_SKILL_REQUEST, createSkillSaga);
  yield takeEvery(UPDATING_SKILL_REQUEST, updateSkillSaga);
  yield takeEvery(DELETING_SKILL_REQUEST, deleteSkillSaga);
  yield takeEvery(UPDATE_SKILLS_PREFERENCES_REQUEST, updateSkillPreferencesSaga);
  yield takeEvery(FETCH_ASSESSMENT_CONFIGURATION_REQUEST, fetchAssessmentConfigurationSaga);
  yield takeLatest(FETCH_ASSESSMENT_CONFIGURATIONS_REQUEST, fetchAssessmentConfigurationsSaga);
  yield takeEvery(CREATE_ASSESSMENT_CONFIGURATION_REQUEST, createAssessmentConfigurationSaga);
  yield takeEvery(UPDATE_ASSESSMENT_CONFIGURATION_REQUEST, updateAssessmentConfigurationSaga);
  yield takeEvery(DELETE_ASSESSMENT_CONFIGURATION_REQUEST, deleteAssessmentConfigurationSaga);
  yield takeEvery(PUBLISH_ASSESSMENT_CONFIGURATION_REQUEST, publishAssessmentConfigurationSaga);
  yield takeEvery(DISCARD_ASSESSMENT_CONFIGURATION_DRAFT_REQUEST, discardAssessmentConfigurationSaga);
}